// extracted by mini-css-extract-plugin
export default {"liveSection":"Header_liveSection__prQlE"};